var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-toolbar',{attrs:{"height":"60","color":"white","flat":"","tile":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.prev}},[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }